import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { SidebarRouteConfig } from 'pages/main-routes';
import { NavLink, To, useMatch, useResolvedPath } from 'react-router-dom';
import { useSidebarExpanded } from '../sidebar.context';
import { listItemStyle } from '../sidebar-link/sidebar-link.styles';

export type SidebarLinkProps = { to: To; onClose: () => null } & Omit<
  SidebarRouteConfig,
  'component'
>;

const SidebarBottomLink = ({
  title = () => null,
  icon,
  to,
  onClose,
}: SidebarLinkProps) => {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: `${resolved.pathname}/*`, end: true });
  const expanded = useSidebarExpanded();

  const titleText = title();

  return (
    <Tooltip title={!expanded ? titleText : ''} placement="right">
      <ListItemButton
        color="success"
        sx={{
          borderRadius: listItemStyle.borderRadius,
          color: 'common.white',
          flexGrow: 0,
          justifyContent: expanded ? 'initial' : 'center',
        }}
        component={NavLink}
        to={to}
        selected={!!match}
        onClick={onClose}
        data-testid="SidebarLink.ListItemButton"
      >
        {icon ? (
          <ListItemIcon
            sx={{
              fontSize: 12,
              color: 'inherit',
              minWidth: 0,
              justifyContent: 'center',
              marginRight: expanded ? 1 : 0,
            }}
          >
            {icon}
          </ListItemIcon>
        ) : (
          <ListItemIcon />
        )}
        {expanded && <ListItemText primary={titleText} color="inherit" />}
      </ListItemButton>
    </Tooltip>
  );
};

export default SidebarBottomLink;
